import Config from '../../../config';
import fetch from '../../../utils/fetchService';
import { handleErrors } from '../../../utils/requestHelpers';

export const submitRequest = async ({ typeOfRequest, requestDescription }) => await fetch(
  Config.endpoints.SUPPORT_REQUEST,
  {
    method: 'POST',
    body: JSON.stringify({ typeOfRequest, requestDescription }),
  }
)
  .then(handleErrors({ errorMessage: 'Error sending support request.' }));


export const submitRequestPublic = async ({ typeOfRequest, requestDescription }) => await fetch(
  Config.endpoints.SUPPORT_REQUEST_PUBLIC,
  {
    method: 'POST',
    body: JSON.stringify({ typeOfRequest, requestDescription }),
  }
)
  .then(handleErrors({ errorMessage: 'Error sendind support request.' }));
